import React from "react";

const Checkout = () => {
  return (
    <div
      style={{
        fontSize: "50px",
        color: "blue",
        textAlign: "center",
        marginTop: "15%",
      }}
    >
      Thank you for choosing us.
    </div>
  );
};

export default Checkout;
